// @ts-nocheck

import InputLabelField from '@/components/form-control/InputLabelField'
import { useAuthContext } from '@/features/auth/context'
import { useConfigUI } from '@/features/config/context'
import useRunManualStation from '@/features/config/hooks/controller/useRunManualStation'
import useStationById from '@/features/config/hooks/station/useStationById'
import { yupResolver } from '@hookform/resolvers/yup'
import { LoadingButton } from '@mui/lab'
import { Box, Button, Checkbox, Stack, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import * as yup from 'yup'
import classes from './styles.module.scss'
import useRunManualWithTimeStation from '@/features/config/hooks/controller/useRunManualWithTimeStation'
import { useDispatch } from 'react-redux'
import { fetchStationOverview } from '@/store/slices/StationOverview/stationOverviewSlice'

interface StationModalProps {
  id?: string
  stateStation?: string
  onToggleSuccess?: (status: 'On' | 'Off') => void
}

const schema = yup
  .object({
    runTime: yup
      .string()
      .required('Run Time is required')
      .max(120, 'Run Time must be less than or equal to 120'),
    cycle: yup
      .string()
      .required('Cycle is required')
      .max(120, 'Cycle must be less than or equal to 120')
      .test(
        'is-less-than-runtime',
        'Cycle must be less than or equal to Run Time',
        function (value) {
          const runTime = this.parent.runTime
          if (typeof value === 'string' && typeof runTime === 'string') {
            return parseInt(value, 10) <= parseInt(runTime, 10)
          }
          return true
        },
      )
      .matches(/^\d+$/, 'Cycle must be an integer'),
    soak: yup
      .string()
      .required('Soak is required')
      .max(120, 'Soak must be less than or equal to 120')
      .matches(/^\d+$/, 'Soak must be an integer'),
  })
  .required()

const StationModal = ({ id, stateStation, onToggleSuccess }: StationModalProps) => {
  const { closeModal } = useConfigUI()
  const { interfaceId } = useAuthContext()
  const dispatch = useDispatch()

  const [checked, setChecked] = useState(false)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked)
  }

  const { mutate: runStation, isLoading } = useRunManualWithTimeStation()

  const { data } = useStationById(interfaceId, id, {
    retry: 0,
  })

  const form = useForm({
    defaultValues: {
      cycle: 0,
      soak: 0,
    } as any,
    resolver: yupResolver(schema),
  })

  const { clearErrors } = form

  useEffect(() => {
    if (!checked) {
      form.setValue('cycle', 0)
      form.setValue('soak', 0)
      clearErrors('cycle')
      clearErrors('soak')
    }
  }, [checked])

  const handleSave = (data: any) => {
    runStation(
      {
        id: Number(id) || 0,
        interfaceId: interfaceId,
        runtime: data.runTime * 60,
        cycle: checked ? data.cycle * 60 : 0,
        soak: checked ? data.soak * 60 : 0,
      },
      {
        onSuccess: () => {
          toast.success(
            stateStation === 'On'
              ? 'On Station Success'
              : 'Off Station Success',
          )
          // Notify parent about successful toggle
          onToggleSuccess?.(stateStation === 'On' ? 'On' : 'Off')
          // Refetch station overview to sync with server
          if (id && interfaceId) {
            dispatch(fetchStationOverview({ interfaceId, stationId: id }) as any)
            setTimeout(() => dispatch(fetchStationOverview({ interfaceId, stationId: id }) as any), 2000)
          }
          closeModal()
        },
        onError: () => {
          closeModal()
        },
      },
    )
  }

  return (
    <form onSubmit={form.handleSubmit(handleSave)}>
      <Stack className={classes.root}>
        <Stack direction="row" spacing={1}>
          <Typography className={classes.txtHeader}>Run</Typography>
          <Typography className={classes.txtHeader}>
            (<>{data?.controller?.name}</>)
          </Typography>
        </Stack>
        <Box width="100%" borderRadius="8px" mt="10px">
          <InputLabelField
            isRequired
            name="runTime"
            form={form}
            label="Run Time(min)"
            placeholder="Enter Run Time"
            style={{
              borderRadius: '8px',
              width: { xs: '100%' },
            }}
          />
        </Box>

        {checked && (
          <Stack mt="10px">
            <Box width="100%" borderRadius="8px">
              <InputLabelField
                isRequired
                name="cycle"
                form={form}
                label="Cycle (min)"
                placeholder="Enter Cycle"
                style={{
                  borderRadius: '8px',
                  width: { xs: '100%' },
                }}
              />
            </Box>

            <Box width="100%" borderRadius="8px" mt="10px">
              <InputLabelField
                isRequired
                name="soak"
                form={form}
                label="Soak (min)"
                placeholder="Enter Soak"
                style={{
                  borderRadius: '8px',
                  width: { xs: '100%' },
                }}
              />
            </Box>
          </Stack>
        )}

        <Stack direction="row" spacing={1} mt="20px" justifyContent="flex-end">
          <Button variant="secondary" onClick={() => closeModal()}>
            Cancel
          </Button>
          <LoadingButton loading={isLoading} variant="primary" type="submit">
            Run
          </LoadingButton>
        </Stack>
      </Stack>
    </form>
  )
}

export default StationModal
